export const RankingsData = [
  {
    tourCode: "MT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Holger Vitus Nodskov",
        playerFamilyName: "Rune",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  },
  {
    tourCode: "WT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Roger",
        playerFamilyName: "Federa",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  },
  {
    tourCode: "JT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Tim",
        playerFamilyName: "Henman",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "SPA",
        rankMovement: "+1",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  },
  {
    tourCode: "VT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "USA",
        rankMovement: "-1",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  },
  {
    tourCode: "WCT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "1",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "USA",
        rankMovement: "1",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  },
  {
    tourCode: "BT",
    items: [
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      },
      {
        playerNationalityCode: "USA",
        rankMovement: "0",
        playerGivenName: "Rafal",
        playerFamilyName: "Nadal",
        playerId: 800361650,
        profileImage:
          "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132253091310000000",
        profileLink: "/en/players/hugo-gaston/800361650/fra/"
      }
    ]
  }
];

const groups = [
  {
    tour: "World",
    tourCode: ["MT", "WT", "JT"]
  },
  {
    tour: "Senior",
    tourCode: ["VT"]
  },
  {
    tour: "Wheelchair",
    tourCode: ["WCT"]
  },
  {
    tour: "Beach",
    tourCode: ["BT"]
  }
];

export const process = (RankingData: any, host?: string) =>
  groups.map(group => {
    let items: any = [];

    RankingData.filter((rankings: any) =>
      group.tourCode.includes(rankings.TourCode)
    ).forEach((r: any) =>
      r.Items.forEach((item: any) =>
        items.push({ ...item, tourCode: r.TourCode })
      )
    );

    if (group.tour === "Wheelchair") {
      const filterValue = Math.floor(Math.random() * 2) + 3;
      items.splice(filterValue, 1);
    }

    if (group.tour === "Senior") {
      const filterValue = Math.floor(Math.random() * (items.length / 2)) * 2;
      items = items.slice(filterValue, filterValue + 2);
    }

    return {
      tour: group.tour,
      items,
      host
    };
  });

export const rankingsResolvedValue = [
  {
    TourCode: "MT",
    Items: [
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "FRA",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/mens-world-tennis-tour-rankings/?matchType=S",
        PlayerGivenName: "Hugo",
        PlayerFamilyName: "Gaston",
        PlayerId: 800361650,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132189176550000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?crop=0.0000000000000001297794951160,0.076651077248629254,0,0.02260112313519699&cropmode=percentage&width=219&height=282&rnd=132189176550000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132189176550000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7f1250b588c.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132189176550000000"
          }
        ],
        ProfileLink: "/en/players/hugo-gaston/800361650/fra/mt/",
        PlayerType: "Men",
        MatchType: "Singles"
      }
    ]
  },
  {
    TourCode: "WT",
    Items: [
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "ROU",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/womens-world-tennis-tour-rankings/?matchType=D",
        PlayerGivenName: "Oana Georgeta",
        PlayerFamilyName: "Simion",
        PlayerId: 800329736,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137989e56609489039fe08.jpg?crop=0.1930268567478482,0.29619907415618735,0.20819595497311255,0.008531242794558554&cropmode=percentage&width=304&height=392&rnd=132221040940000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137989e56609489039fe08.jpg?crop=0.19303832042745817,0.28946672209834079,0.1941826889340173,0&cropmode=percentage&width=219&height=282&rnd=132221040940000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137989e56609489039fe08.jpg?crop=0.24769276285422218,0.29274412769220026,0.28788330679411123,0.010246044469227675&cropmode=percentage&width=150&height=250&rnd=132221040940000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137989e56609489039fe08.jpg?crop=0.34538379902305361,0.31185305139109115,0.32646598532782661,0.29415532093099628&cropmode=percentage&width=54&height=72&rnd=132221040940000000"
          }
        ],
        ProfileLink: "/en/players/oana-georgeta-simion/800329736/rou/wt/",
        PlayerType: "Women",
        MatchType: "Singles"
      }
    ]
  },
  {
    TourCode: "JT",
    Items: [
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "DEN",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/world-tennis-tour-junior-rankings/?playerType=B",
        PlayerGivenName: "Holger Vitus Nodskov",
        PlayerFamilyName: "Rune",
        PlayerId: 800418841,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866be37fe2e.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132120787270000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866be37fe2e.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132120787270000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866be37fe2e.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132120787270000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866be37fe2e.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132120787270000000"
          }
        ],
        ProfileLink: "/en/players/holger-vitus-nodskov-rune/800418841/den/jt/",
        PlayerType: "Boys",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "FRA",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/world-tennis-tour-junior-rankings/?playerType=G",
        PlayerGivenName: "Elsa",
        PlayerFamilyName: "Jacquemot",
        PlayerId: 800465302,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866887bfe08.jpg?crop=0.23584497344088137,0,0.26059413732048,0&cropmode=percentage&width=304&height=392&rnd=132189189690000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866887bfe08.jpg?crop=0.2023126734505088,0,0.25069380203515268,0&cropmode=percentage&width=219&height=282&rnd=132189189690000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866887bfe08.jpg?crop=0.25638260869565216,0,0.32100869565217394,0&cropmode=percentage&width=150&height=250&rnd=132189189690000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999e1220866887bfe08.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132189189690000000"
          }
        ],
        ProfileLink: "/en/players/elsa-jacquemot/800465302/fra/jt/",
        PlayerType: "Girls",
        MatchType: "Singles"
      }
    ]
  },
  {
    TourCode: "VT",
    Items: [
      {
        AgeCategoryDescription: "Over 35",
        PlayerNationalityCode: "UKR",
        RankMovement: 3,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Andriy",
        PlayerFamilyName: "Baidikov",
        PlayerId: 800508771,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/andriy-baidikov/800508771/ukr/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 35",
        PlayerNationalityCode: "GER",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Manon",
        PlayerFamilyName: "Kruse",
        PlayerId: 800141540,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/manon-kruse/800141540/ger/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 40",
        PlayerNationalityCode: "ESP",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Roberto",
        PlayerFamilyName: "Menendez Ferre",
        PlayerId: 800185712,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/roberto-menendez-ferre/800185712/esp/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 40",
        PlayerNationalityCode: "NED",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Regina",
        PlayerFamilyName: "Balcune",
        PlayerId: 800403000,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/regina-balcune/800403000/ned/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 45",
        PlayerNationalityCode: "CHI",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Gonzalo",
        PlayerFamilyName: "Ambiado",
        PlayerId: 800183880,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/gonzalo-ambiado/800183880/chi/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 45",
        PlayerNationalityCode: "ITA",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Valentina",
        PlayerFamilyName: "Padula",
        PlayerId: 800133646,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/valentina-padula/800133646/ita/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 50",
        PlayerNationalityCode: "FIN",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Alexander",
        PlayerFamilyName: "Lindholm",
        PlayerId: 800182054,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/alexander-lindholm/800182054/fin/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 50",
        PlayerNationalityCode: "BRA",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Monica",
        PlayerFamilyName: "Yanagi",
        PlayerId: 800374918,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/monica-yanagi/800374918/bra/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 55",
        PlayerNationalityCode: "GER",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Christian",
        PlayerFamilyName: "Greuter",
        PlayerId: 800423968,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/christian-greuter/800423968/ger/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 55",
        PlayerNationalityCode: "NED",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Liselot",
        PlayerFamilyName: "Prechtel",
        PlayerId: 800214007,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999f1240876947dfd2e.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132120787570000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999f1240876947dfd2e.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132120787570000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999f1240876947dfd2e.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132120787570000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999f1240876947dfd2e.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132120787570000000"
          }
        ],
        ProfileLink: "/en/players/liselot-prechtel/800214007/ned/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 60",
        PlayerNationalityCode: "AUS",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Glenn",
        PlayerFamilyName: "Busby",
        PlayerId: 800176560,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/glenn-busby/800176560/aus/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 60",
        PlayerNationalityCode: "USA",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Carolyn",
        PlayerFamilyName: "Nichols",
        PlayerId: 800198114,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/carolyn-nichols/800198114/usa/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 65",
        PlayerNationalityCode: "NED",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Frits",
        PlayerFamilyName: "Raijmakers",
        PlayerId: 800326217,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/frits-raijmakers/800326217/ned/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 65",
        PlayerNationalityCode: "USA",
        RankMovement: 2,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Carolyn",
        PlayerFamilyName: "Nichols",
        PlayerId: 800198114,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/carolyn-nichols/800198114/usa/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 70",
        PlayerNationalityCode: "ESP",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Jairo",
        PlayerFamilyName: "Velasco Ramirez",
        PlayerId: 800194884,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/jairo-velasco-ramirez/800194884/esp/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 70",
        PlayerNationalityCode: "AUS",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Kerry",
        PlayerFamilyName: "Ballard",
        PlayerId: 800174663,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/kerry-ballard/800174663/aus/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 75",
        PlayerNationalityCode: "AUT",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Peter",
        PlayerFamilyName: "Pokorny",
        PlayerId: 800174082,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/peter-pokorny/800174082/aut/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 75",
        PlayerNationalityCode: "GER",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Heide",
        PlayerFamilyName: "Orth",
        PlayerId: 800204002,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/heide-orth/800204002/ger/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 80",
        PlayerNationalityCode: "CHI",
        RankMovement: 1,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Jaime Rene",
        PlayerFamilyName: "Pinto Bravo",
        PlayerId: 800174080,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/jaime-rene-pinto-bravo/800174080/chi/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 80",
        PlayerNationalityCode: "AUS",
        RankMovement: 8,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Mary",
        PlayerFamilyName: "Gordon",
        PlayerId: 800206190,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/mary-gordon/800206190/aus/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 85",
        PlayerNationalityCode: "USA",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "King",
        PlayerFamilyName: "Van Nostrand",
        PlayerId: 800175198,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/king-van-nostrand/800175198/usa/vt/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: "Over 85",
        PlayerNationalityCode: "USA",
        RankMovement: 0,
        RankingsLink: "/en/rankings/seniors-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Burnett",
        PlayerFamilyName: "Herrick",
        PlayerId: 800196779,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/burnett-herrick/800196779/usa/vt/",
        PlayerType: "Women",
        MatchType: "Singles"
      }
    ]
  },
  {
    TourCode: "WCT",
    Items: [
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "JPN",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/uniqlo-wheelchair-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Shingo",
        PlayerFamilyName: "Kunieda",
        PlayerId: 800231597,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c32009589c7fff18.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132120787330000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c32009589c7fff18.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132120787330000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c32009589c7fff18.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132120787330000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c32009589c7fff18.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132120787330000000"
          }
        ],
        ProfileLink: "/en/players/shingo-kunieda/800231597/jpn/wct/",
        PlayerType: "Men",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "NED",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/uniqlo-wheelchair-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Diede",
        PlayerFamilyName: "De Groot",
        PlayerId: 800366561,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c3200866b67dfe18.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132120787380000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c3200866b67dfe18.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132120787380000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c3200866b67dfe18.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132120787380000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=221379a7c3200866b67dfe18.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132120787380000000"
          }
        ],
        ProfileLink: "/en/players/diede-de-groot/800366561/ned/wct/",
        PlayerType: "Women",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "AUS",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/uniqlo-wheelchair-tennis-tour-rankings/?playerType=Q",
        PlayerGivenName: "Dylan",
        PlayerFamilyName: "Alcott",
        PlayerId: 800257258,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cb240958987afe08.jpg?crop=0.25120772946859904,0.022288261515601784,0.36023379283039014,0.14188384339025434&cropmode=percentage&width=304&height=392&rnd=132173302390000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cb240958987afe08.jpg?crop=0.28092810631736387,0.03200270651460807,0.39355202445775422,0.32337134797685796&cropmode=percentage&width=219&height=282&rnd=132173302390000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cb240958987afe08.jpg?crop=0.31093093362427959,0.025020920269447498,0.41790836844756957,0.27995351669034424&cropmode=percentage&width=150&height=250&rnd=132173302390000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cb240958987afe08.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132173302390000000"
          }
        ],
        ProfileLink: "/en/players/dylan-alcott/800257258/aus/wct/",
        PlayerType: "Quad",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "NED",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/uniqlo-wheelchair-tennis-tour-rankings/?playerType=B",
        PlayerGivenName: "Niels",
        PlayerFamilyName: "Vink",
        PlayerId: 800514079,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/niels-vink/800514079/ned/wct/",
        PlayerType: "Boys",
        MatchType: "Singles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "BRA",
        RankMovement: 0,
        RankingsLink:
          "/en/rankings/uniqlo-wheelchair-tennis-tour-rankings/?playerType=G",
        PlayerGivenName: "Jade",
        PlayerFamilyName: "Lanai",
        PlayerId: 800541601,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/jade-lanai/800541601/bra/wct/",
        PlayerType: "Girls",
        MatchType: "Singles"
      }
    ]
  },
  {
    TourCode: "BT",
    Items: [
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "ITA",
        RankMovement: 0,
        RankingsLink: "/en/rankings/beach-tennis-tour-rankings/?playerType=M",
        PlayerGivenName: "Alessandro",
        PlayerFamilyName: "Calbucci",
        PlayerId: 800635495,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1490/itf-uk-profile-placeholder-male.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/alessandro-calbucci/800635495/ita/bt/",
        PlayerType: "Men",
        MatchType: "Doubles"
      },
      {
        AgeCategoryDescription: null,
        PlayerNationalityCode: "BRA",
        RankMovement: 0,
        RankingsLink: "/en/rankings/beach-tennis-tour-rankings/?playerType=W",
        PlayerGivenName: "Rafaella",
        PlayerFamilyName: "Miiller",
        PlayerId: 800638405,
        ProfilePictureUrls: [
          {
            cropKey: "Large",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=304&height=392&rnd=132174204480000000"
          },
          {
            cropKey: "Medium",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=219&height=282&rnd=132174204480000000"
          },
          {
            cropKey: "Small",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=150&height=250&rnd=132174204480000000"
          },
          {
            cropKey: "ExtraSmall",
            imageUrl:
              "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
          }
        ],
        ProfileLink: "/en/players/rafaella-miiller/800638405/bra/bt/",
        PlayerType: "Women",
        MatchType: "Doubles"
      }
    ]
  }
];
